import './patrickproperties/style';
import FormStructure from './patrickproperties/form_structure';

export default FormStructure;